import React, { useEffect, useState } from "react";
import { ModalBody } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { Modal, ModalFooter, ModalHeader } from "reactstrap";
import {
  getAddsOneGroup,
  postAddsOne,
  editAddsOne,
  postAddsOneGroup,
} from "../../../MyApi/addsone";
import { toast } from "react-toastify";
import AddIcon from "../../Common/svg/addicon";
import EnhancedSearchProduct from "../../UI/enhancedproductsearch";
import i18next from "i18next";
import { formatPrice } from "../../../utils/formatPrice";

const AddsOneEditModal = ({
  isOpen,
  closeModal,
  refetch,
  store_id,
  addonId,
  modalMode, // "add" or "edit"
  currency_factor,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    price: "",
    applicable_to: "product",
    group_id: "",
  });

  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [groupName, setGroupName] = useState("");

  const [isLinkedToProduct, setIsLinkedToProduct] = useState(false);
  const [linkedProductId, setLinkedProductId] = useState("");
  const [linkedProductName, setLinkedProductName] = useState("");

  /* ---------------- ADDON GROUPS ---------------- */
  const { data: groupsData, refetch: refetchGroups } = useQuery(
    ["getAddsOneGroups", store_id],
    () => getAddsOneGroup(store_id)
  );

  const addsOneGroup = groupsData?.data?.add_on_groups || [];

  /* ---------------- GET ADDON (EDIT MODE) ---------------- */
  const { data: addonData } = useQuery(
    ["getAddon", addonId],
    async () => {
      // fetch all groups and addons
      const res = await getAddsOneGroup(store_id);
      if (!res?.data?.add_on_groups) return null;

      // find the addon by ID
      for (const group of res.data.add_on_groups) {
        const addon = group.add_ons.find((a) => a.id === addonId);
        if (addon) {
          return {
            ...addon,
            group_id: group.id,
            group_name: group.name,
          };
        }
      }
      return null;
    },
    {
      enabled: modalMode === "edit" && !!addonId,
    }
  );
 console.log('addonData', addonData)
  /* ---------------- FILL FORM ON EDIT ---------------- */
  useEffect(() => {
    if (modalMode === "edit" && addonData) {
      setFormData({
        name: addonData.name || "",
        price: formatPrice( currency_factor,addonData.price) || "",
        applicable_to: addonData.applicable_to || "product",
        group_id: addonData.group_id || "",
        lang:i18next.language,
        
      });

      // Optional: if addon linked to product
      setIsLinkedToProduct(addonData.applicable_to === "linked_product");
      if (addonData.linked_product_id) {
        setLinkedProductId(addonData.linked_product_id);
        setLinkedProductName(addonData.linked_product_name || "");
      }
    }
  }, [addonData, modalMode]);

  /* ---------------- ADD / EDIT ADDON ---------------- */
  const mutation = useMutation({
    mutationFn: (postData) =>
      modalMode === "edit"
        ? editAddsOne({ _method: "PUT", lang: i18next.language, ...postData }, addonId)
        : postAddsOne(postData),

    onSuccess: (data) => {
      toast.success(data.message);

      setFormData({
        name: "",
        price: "",
        applicable_to: "product",
        group_id: "",
      });

      refetch();
      closeModal();
    },

    onError: (error) => {
      toast.error(error.response?.data?.message || "حدث خطأ");
    },
  });

  /* ---------------- CREATE GROUP ---------------- */
  const groupMutation = useMutation({
    mutationFn: (postData) => postAddsOneGroup(postData),
    onSuccess: (data) => {
      toast.success(data.message);
      setGroupName("");
      setIsGroupModalOpen(false);
      refetchGroups();
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "حدث خطأ");
    },
  });

  /* ---------------- HANDLERS ---------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLinkedProductChange = (e) => {
    const checked = e.target.checked;
    setIsLinkedToProduct(checked);

    if (checked) {
      setFormData((prev) => ({ ...prev, name: "" }));
      setLinkedProductId("");
    }
  };

  const handleProductSelect = (productId, productName) => {
    setLinkedProductId(productId);
    setLinkedProductName(productName);
  };

  const handleSubmit = () => {
    const postData = {
      price: formData.price,
      applicable_to: "product",
      store_id,
      add_on_group_id: formData.group_id,
    
    };

    if (isLinkedToProduct && linkedProductId) {
      postData.linked_product_id = linkedProductId;
    } else {
      postData.name = formData.name;
    }

    mutation.mutate(postData);
  };

  const handleCreateGroup = () => {
    if (!groupName.trim()) {
      toast.error("الرجاء إدخال اسم المجموعة");
      return;
    }

   groupMutation.mutate({
      name: groupName,
      store_id,
      is_active: 1,
    });
 
   
  };

  return (
    <>
      {/* ---------------- ADD / EDIT MODAL ---------------- */}
      <Modal isOpen={isOpen} toggle={closeModal}>
        <ModalHeader toggle={closeModal}>
          {modalMode === "edit" ? "تعديل الإضافة" : "إضافة إضافة"}
        </ModalHeader>

        <ModalBody>
          <div className="row add">
            <div className="col-12">
              {/* LINK PRODUCT */}
              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={isLinkedToProduct}
                  onChange={handleLinkedProductChange}
                />
                <label className="form-check-label">اختيار من منتج</label>
              </div>

              {isLinkedToProduct ? (
                <>
                  <label className="form-label">اختر المنتج</label>
                  <EnhancedSearchProduct
                    storeId={store_id}
                    setProductId={handleProductSelect}
                    value={
                      linkedProductId
                        ? { id: linkedProductId, name: linkedProductName }
                        : null
                    }
                  />
                </>
              ) : (
                <>
                  <label className="form-label">اسم الإضافة</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </>
              )}
            </div>

            {/* PRICE */}
            <div className="col-12 mt-3">
              <label className="form-label">سعر الإضافة</label>
              <input
                type="number"
                name="price"
                className="form-control"
                value={formData.price}
                onChange={handleChange}
              />
            </div>

            {/* GROUP */}
            <div className="col-12 mt-3">
              <div className="d-flex align-items-center gap-2">
                <label className="form-label mb-0">مجموعة الإضافات</label>
                <button
                  className="btn btn-primary btn-sm p-1"
                  type="button"
                  onClick={() => setIsGroupModalOpen(true)}
                >
                  <AddIcon />
                </button>
              </div>

              <select
                className="form-control"
                name="group_id"
                value={formData.group_id}
                onChange={handleChange}
              >
                <option value="">اختر مجموعة</option>
                {addsOneGroup.map((group) => (
                  <option key={group.id} value={group.id}>
                    {group.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="d-flex justify-content-center gap-3 mt-4">
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={mutation.isLoading}
            >
              {mutation.isLoading
                ? "جاري الحفظ..."
                : modalMode === "edit"
                ? "تحديث"
                : "إضافة"}
            </button>

            <button className="btn btn-white" onClick={closeModal}>
              إلغاء
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* ---------------- CREATE GROUP MODAL ---------------- */}
      <Modal
        isOpen={isGroupModalOpen}
        toggle={() => setIsGroupModalOpen(false)}
      >
        <ModalHeader toggle={() => setIsGroupModalOpen(false)}>
          إضافة مجموعة إضافات
        </ModalHeader>

        <ModalBody>
          <label className="form-label">اسم المجموعة</label>
          <input
            className="form-control"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
          />
        </ModalBody>

        <ModalFooter>
          <button
            className="btn btn-primary"
            onClick={handleCreateGroup}
            disabled={groupMutation.isLoading}
          >
            {groupMutation.isLoading ? "جاري الإضافة..." : "إضافة"}
          </button>

          <button
            className="btn btn-white"
            onClick={() => setIsGroupModalOpen(false)}
          >
            إلغاء
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AddsOneEditModal;